import Immutable from 'immutable'

export function forceImmutable (obj) {
  return Immutable.Iterable.isIterable(obj)
    ? obj
    : Immutable.fromJS(obj)
}



// WEBPACK FOOTER //
// ./client/src/util/immutableUtils.js